// This target measures prepared inputs, leaving ingress headroom for the expanded
// GraphQL variables, mutation document, and request envelope.
export const TARGET_BATCH_INPUT_BYTES = 750 * 1024;

const encoder = new TextEncoder();
const byteLength = value => encoder.encode(JSON.stringify(value)).length;

export default function chunkInputsByByteSize(inputs, maxInputBytes = TARGET_BATCH_INPUT_BYTES) {
  const batches = [];
  let currentBatch = [];
  let currentBytes = 0;

  inputs.forEach(input => {
    const inputBytes = byteLength(input);

    if (currentBatch.length && currentBytes + inputBytes > maxInputBytes) {
      batches.push(currentBatch);
      currentBatch = [];
      currentBytes = 0;
    }

    currentBatch.push(input);
    currentBytes += inputBytes;
  });

  if (currentBatch.length) {
    batches.push(currentBatch);
  }

  return batches;
}
